import type { InternalAxiosRequestConfig } from 'axios';
import qs from 'qs';

export const queryParamsMiddleware = (
  req: InternalAxiosRequestConfig
): InternalAxiosRequestConfig => ({
  ...req,
  paramsSerializer: {
    serialize: params => qs.stringify(params, { arrayFormat: 'repeat' }),
  },
});
